// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2q1Pv","paramInput":"JobSimulator_paramInput__2gOkl","input":"JobSimulator_input__278RV"};